import React from 'react';
import InsightsPortal from '../portals/InsightsPortal';
import WorkspacesPortal from '../portals/WorkspacesPortal';
import UnsplashPortal from '../portals/UnsplashPortal';
import UserUploadPortal from '../portals/UserUploadPortal';
import LockerDetailsPortal from '../portals/LockerDetailsPortal';
import LockerManagementPortal from '../portals/LockerManagementPortal';
import AuthorHistoryPortal from '@/components/portals/AuthorHistoryPortal';
import LanguagesPortal from '../portals/LanguagesPortal';
import ContentTranslationsPortal from '@/components/portals/ContentTranslationsPortal';
import SystemAdminPortal from '@/components/portals/SystemAdminPortal';
import PlannerPortal from '@/components/portals/PlannerPortal';
import SearchPortal from '@/components/portals/SearchPortal';
import PlannerSettingsPortal from '@/components/portals/PlannerSettingsPortal';
import ArchivePortal from '@/components/portals/ArchivePortal';
import SchedulePushPortal from '@/components/portals/SchedulePushPortal';
import ConfirmModal from '@/components/portals/ConfirmationModal';
import InformationPortal from '@/components/portals/InformationPortal';
import AcknowledgementPortal from '@/components/portals/AcknowledgementsPortal';
import ShareControlsPortal from '@/components/portals/ShareControlPortal';
import WidgetsPortal from '@/components/portals/WidgetsPortal';
import UserWorkspacesTabPortal from '@/components/portals/OrgSettings/Users/WorkspacesPortal';
import AdminDetailsPortal from '@/components/portals/OrgSettings/Users/AdminDetailsPortal';
import AllUsersPortal from '@/components/portals/OrgSettings/Users/AllUsersPortal';
import AllUserGroupsPortal from '@/components/portals/OrgSettings/UserGroups/UserGroupsTabPortal';
import ContentAudiencePortal from '@/components/portals/ContentAudiencePortal';
import UsersPortal from '@/components/portals/OrgSettings/Workspaces/UsersPortal';
import UserGroupsPortal from '@/components/portals/OrgSettings/Workspaces/UserGroupsPortal';
import MainMenuProvider from '@/context/ListContext';
import DraftsPortal from '@/components/portals/Content/DraftsTab/DraftsPortal';
import OrgSettingsProvider from '@/context/OrgSettings';
import OrgSettingsWorkspaceProvider from '@/context/OrgSettingsWorkspaceContext';
import OrgSettingsUsersProvider from '@/context/OrgSettingsUsersContext';
import OrgSettingsUserGroupsProvider from '@/context/OrgSettingsUserGroupsContext';
import MainMenuPortal from '@/components/portals/Content/MenuTab/MainMenuPortal';
import ContentListPortal from '@/components/portals/Content/ContentList/ContentListPortal';
import DownloadContentReportPortal from '@/components/portals/Content/DownloadContentReport/DownloadContentReportPortal';
import UserGroupsUserTabPortal from '@/components/portals/OrgSettings/UserGroups/UserGroupsUserTabPortal';
import ContentUGCPermissionsPortal from '@/components/portals/ContentUGCPermissionsPortal';
import UserGroupsWorkspacesTabPortal from '@/components/portals/OrgSettings/UserGroups/UserGroupsWorkspaceTabPortal';
import ActivityFeedProvider from '@/context/ActivityFeedContext';
import ActivityFeedPagePortal from '@/components/portals/ActivityFeed/ActivityFeedPagePortal';
import ActivityFeedPopOutPortal from '@/components/portals/ActivityFeed/ActivityFeedPopOutPortal';
import RestoreContentFromPagePortal from '@/components/portals/RestoreContentFromPagePortals';
import ToastOnLoadPortal from '@/components/portals/ToastPortal';
import SpotlightCarouselPortal from '@/components/portals/Spotlight/SpotlightCarouselPortal';
import SpotlightProvider from '@/context/SpotlightContext';
import BreadCrumbsPortal from '@/components/portals/BreadCrumbs/BreadCrumbsPortal';
import DisplayInformationPopUpModalPortal from '@/components/portals/Content/AppearanceTab/DisplayInformationPopUpModalPortal';
import FormBuilderPortal from '@/components/portals/FormBuilderPortal';
import FormDetailsPortal from '@/components/portals/FormDetailsPortal';
import ManageYourPasskeysPortal from '@/components/portals/Manage/ManageYourPasskeysPortal';
import PasskeySettingsPortal from '@/components/portals/OrgSettings/Passkeys/PasskeySettingsPortal';
import UserPasskeysInformationPortal from '@/components/portals/OrgSettings/Users/UserPasskeysInformationPortal';
import SelfSignUpTrialPortal from '@/components/portals/NavigationBar/SelfSignUpTrialPortal';
import SharedCombinedFeedPortals from '@/components/portals/Content/CombinedFeed/SharedCombinedFeedPortal';
import ListLayoutPortal from '@/components/portals/Content/AppearanceTab/ListLayoutPortal';
import UserGroupSyncPortal from "@/components/portals/UserGroupSync/UserGroupSyncPortal.tsx";
import HomePortal from '../portals/HomePortal';

class App extends React.Component<{}, {}> {

    render() {
        return (
            <>
                <InsightsPortal />   
                <WorkspacesPortal />
                <UnsplashPortal />
                <UserUploadPortal />
                <LockerDetailsPortal />
                <LockerManagementPortal />
                <LanguagesPortal />    
                <ContentTranslationsPortal />
                <AuthorHistoryPortal />
                <SystemAdminPortal />
                <PlannerPortal />
                <SearchPortal />
                <PlannerSettingsPortal />
                <ArchivePortal />
                <SchedulePushPortal />
                <ConfirmModal />
                <InformationPortal />
                <AcknowledgementPortal />
                <ShareControlsPortal />
                <WidgetsPortal />
                <ContentAudiencePortal />
                <ContentUGCPermissionsPortal />
                <OrgSettingsProvider>
                    <OrgSettingsWorkspaceProvider>
                        <UserGroupsPortal />
                        <UsersPortal />
                    </OrgSettingsWorkspaceProvider>

                    <OrgSettingsUsersProvider>
                        <AllUsersPortal /> 
                        <AdminDetailsPortal />
                        <UserWorkspacesTabPortal />
                        <UserPasskeysInformationPortal />
                    </OrgSettingsUsersProvider>

                    <OrgSettingsUserGroupsProvider>
                        <AllUserGroupsPortal />
                        <UserGroupsUserTabPortal />
                        <UserGroupsWorkspacesTabPortal />
                    </OrgSettingsUserGroupsProvider>

                    <ManageYourPasskeysPortal />
                    <PasskeySettingsPortal />
                </OrgSettingsProvider>

                <MainMenuProvider isMainMenu={true}>
                    <MainMenuPortal />
                </MainMenuProvider>
                <MainMenuProvider isMainMenu={false}>
                    <ContentListPortal />
                    <DownloadContentReportPortal />
                    <SharedCombinedFeedPortals />
                </MainMenuProvider>

                <DraftsPortal />

                <ActivityFeedProvider >
                    <ActivityFeedPagePortal />
                    <ActivityFeedPopOutPortal />
                </ActivityFeedProvider>

                <SpotlightProvider>
                    <HomePortal />
                    <SpotlightCarouselPortal />
                </SpotlightProvider>

                <SelfSignUpTrialPortal />

                <RestoreContentFromPagePortal />
                <ToastOnLoadPortal />
                <BreadCrumbsPortal />

                <DisplayInformationPopUpModalPortal />
                <ListLayoutPortal />
                <FormBuilderPortal />
                <FormDetailsPortal />
                <UserGroupSyncPortal />
            </>
        );
    }
}

export default App;